import { render, staticRenderFns } from "./MarkdownContent.vue?vue&type=template&id=1075953c"
import script from "./MarkdownContent.vue?vue&type=script&lang=js"
export * from "./MarkdownContent.vue?vue&type=script&lang=js"
import style0 from "./MarkdownContent.vue?vue&type=style&index=0&id=1075953c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports